export default __webpack_public_path__ + "static/media/covid19.2556b48a.png";